(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wldk-brand-bar"] && !Shopify.designMode) return;
  try {
    
class WldkBrandBar {
  constructor(el) {
    this.el = el;
    this.viewport = el.querySelector('.wldk-bb__viewport');
    this.marquee = el.querySelector('.wldk-bb__marquee');
    this.group = this.marquee ? this.marquee.querySelector('.wldk-bb__group') : null;
    this.lastWidth = 0;
    if (!this.marquee || !this.group) return;
    this.el.__wldkInit = true;
    this.bind();
    this.build();
  }

  reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  motionOn() {
    if (this.reducedMotion()) return false;
    const m = this.el.dataset.motion;
    if (m === 'always') return true;
    if (m === 'mobile') return window.matchMedia('(max-width: 749px)').matches;
    return false;
  }

  clearClones() {
    this.marquee.querySelectorAll('.wldk-bb__group--clone').forEach((n) => n.remove());
  }

  build() {
    this.clearClones();

    if (!this.motionOn()) {
      this.el.dataset.static = 'true';
      this.el.style.removeProperty('--wldk-shift');
      this.el.style.removeProperty('--wldk-duration');
      return;
    }

    const gapStr = getComputedStyle(this.marquee).columnGap || getComputedStyle(this.marquee).gap || '0';
    const gap = parseFloat(gapStr) || 0;
    const groupWidth = this.group.getBoundingClientRect().width;

    if (!groupWidth) {
      this.el.dataset.static = 'true';
      return;
    }

    const shift = groupWidth + gap;
    const needed = Math.max(2, Math.ceil((window.innerWidth * 2) / shift));

    for (let i = 1; i < needed; i++) {
      const clone = this.group.cloneNode(true);
      clone.classList.add('wldk-bb__group--clone');
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('a').forEach((a) => {
        a.setAttribute('tabindex', '-1');
        a.removeAttribute('title');
      });
      this.marquee.appendChild(clone);
    }

    const speed = parseFloat(this.el.dataset.speed) || 40;
    this.el.style.setProperty('--wldk-shift', shift + 'px');
    this.el.style.setProperty('--wldk-duration', (shift / speed).toFixed(3) + 's');
    this.el.dataset.static = 'false';
  }

  rebuild() {
    this.el.dataset.static = 'true';
    requestAnimationFrame(() => this.build());
  }

  bind() {
    this.lastWidth = window.innerWidth;

    let t;
    this._onResize = () => {
      if (window.innerWidth === this.lastWidth) return;
      this.lastWidth = window.innerWidth;
      clearTimeout(t);
      t = setTimeout(() => this.rebuild(), 150);
    };
    window.addEventListener('resize', this._onResize);

    this.el.querySelectorAll('img').forEach((img) => {
      if (!img.complete) {
        img.addEventListener('load', () => this.rebuild(), { once: true });
      }
    });

    if ('IntersectionObserver' in window) {
      this._io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          this.el.dataset.paused = e.isIntersecting ? 'false' : 'true';
        });
      });
      this._io.observe(this.el);
    }
  }

  destroy() {
    window.removeEventListener('resize', this._onResize);
    if (this._io) this._io.disconnect();
  }
}

(function () {
  function initAll(scope) {
    (scope || document).querySelectorAll('.wldk-bb').forEach(function (el) {
      if (!el.__wldkInit) new WldkBrandBar(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('.wldk-bb').forEach(function (el) {
      if (el.__wldkInit) return;
      new WldkBrandBar(el);
    });
  });

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  document.addEventListener('shopify:block:select', function (e) {
    var bar = e.target.closest ? e.target.closest('.wldk-bb') : null;
    if (bar) bar.dataset.paused = 'true';
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var bar = e.target.closest ? e.target.closest('.wldk-bb') : null;
    if (bar) bar.dataset.paused = 'false';
  });
})();

  } catch(e) { console.error(e); }
})();
})();
